bam-header-search-tab-list {
  display: block;
  margin: 40px 0 24px;

  @include desktop() {
    margin: 48px 0 32px;
  }


  .bam-header-search-tab-list__contact {
    display: flex;

    @include mobile() {
      flex-direction: column;
    }
  }

  .bam-header-search-tab-list__contact__phone {
    margin-top: 16px;

    @include tablet() {
      margin-top: 0;
      margin-left: 32px;
    }
  }
}
